import { render, staticRenderFns } from "./kafkaConfigForm.vue?vue&type=template&id=187259a8&scoped=true&"
import script from "./kafkaConfigForm.vue?vue&type=script&lang=js&"
export * from "./kafkaConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./kafkaConfigForm.vue?vue&type=style&index=0&id=187259a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187259a8",
  null
  
)

export default component.exports